import { axiosInstance } from '@/api/axiosInstance';

export default async function apiUnitDelete(code: string): Promise<boolean> {
    return await axiosInstance.delete(`/v1/units/${code}`);
}